var map = {
	"./1.jpg": 72149,
	"./IMG_0981.JPG": 52936,
	"./IMG_0982.JPG": 86619,
	"./IMG_0983.JPG": 58449,
	"./IMG_0984.JPG": 61310,
	"./IMG_0985.JPG": 41416,
	"./IMG_0986.JPG": 71541,
	"./IMG_0987.JPG": 89186,
	"./IMG_0988.JPG": 15911
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 92291;